import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "location",
  "use": "location-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"location\"><path d=\"M12.5 3C16.094 3 19 5.817 19 9.3c0 4.725-6.5 11.7-6.5 11.7l-.337-.374C10.831 19.12 6 13.373 6 9.3 6 5.817 8.906 3 12.5 3zm0 4.05c-1.281 0-2.321 1.008-2.321 2.25s1.04 2.25 2.321 2.25 2.321-1.008 2.321-2.25-1.04-2.25-2.321-2.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol